import { api } from '../api/client';
import { store } from '../state/store';
import { Era } from '../types';

export function initEraModal(): void {
  const modal = document.getElementById('era-modal');
  const closeBtn = document.getElementById('era-modal-close-btn');
  const cancelBtn = document.getElementById('era-cancel-btn');
  const form = document.getElementById('era-form') as HTMLFormElement;
  const colorInput = document.getElementById('era-color-input') as HTMLInputElement;
  const colorHex = document.getElementById('era-color-hex') as HTMLElement;
  const deleteBtn = document.getElementById('era-delete-btn') as HTMLButtonElement;
  const addEraBtn = document.getElementById('add-era-btn');

  addEraBtn?.addEventListener('click', () => openEraModal());

  closeBtn?.addEventListener('click', closeEraModal);
  cancelBtn?.addEventListener('click', closeEraModal);
  modal?.addEventListener('click', (e) => {
    if (e.target === modal) closeEraModal();
  });

  colorInput?.addEventListener('input', () => {
    if (colorHex) colorHex.textContent = colorInput.value;
  });

  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const idInput = document.getElementById('era-id-input') as HTMLInputElement;
    const titleInput = document.getElementById('era-title-input') as HTMLInputElement;
    const descInput = document.getElementById('era-desc-input') as HTMLTextAreaElement;
    const startInput = document.getElementById('era-start-input') as HTMLInputElement;
    const endInput = document.getElementById('era-end-input') as HTMLInputElement;
    const privateInput = document.getElementById('era-private-checkbox') as HTMLInputElement;

    const isEdit = !!idInput.value;
    const eraId = idInput.value || `era-${Date.now()}`;

    const era: Era = {
      id: eraId,
      title: titleInput.value.trim(),
      description: descInput.value.trim() || null,
      start_date: startInput.value,
      end_date: endInput.value || null,
      color: colorInput.value,
      is_private: privateInput.checked ? 1 : 0,
      display_order: 0,
    };

    try {
      await api.saveEra(era);
      const existing = [...store.meta.eras];
      if (isEdit) {
        const index = existing.findIndex((e) => e.id === eraId);
        if (index !== -1) existing[index] = era;
      } else {
        existing.push(era);
      }
      store.setEras(existing);
      closeEraModal();
    } catch (err) {
      alert(`Failed to save era: ${String(err)}`);
    }
  });

  deleteBtn?.addEventListener('click', async () => {
    const idInput = document.getElementById('era-id-input') as HTMLInputElement;
    const eraId = idInput.value;
    if (!eraId || !confirm('Are you sure you want to delete this chapter?')) return;

    try {
      await api.deleteEra(eraId);
      const filtered = store.meta.eras.filter((e) => e.id !== eraId);
      store.setEras(filtered);
      closeEraModal();
    } catch (err) {
      alert(`Failed to delete era: ${String(err)}`);
    }
  });
}

export function openEraModal(era?: Era): void {
  const modal = document.getElementById('era-modal');
  const titleEl = document.getElementById('era-modal-title');
  const idInput = document.getElementById('era-id-input') as HTMLInputElement;
  const titleInput = document.getElementById('era-title-input') as HTMLInputElement;
  const descInput = document.getElementById('era-desc-input') as HTMLTextAreaElement;
  const startInput = document.getElementById('era-start-input') as HTMLInputElement;
  const endInput = document.getElementById('era-end-input') as HTMLInputElement;
  const colorInput = document.getElementById('era-color-input') as HTMLInputElement;
  const colorHex = document.getElementById('era-color-hex') as HTMLElement;
  const privateInput = document.getElementById('era-private-checkbox') as HTMLInputElement;
  const deleteBtn = document.getElementById('era-delete-btn') as HTMLButtonElement;

  if (!modal) return;

  if (era) {
    if (titleEl) titleEl.textContent = 'Edit Life Chapter';
    idInput.value = era.id;
    titleInput.value = era.title;
    descInput.value = era.description || '';
    startInput.value = era.start_date;
    endInput.value = era.end_date || '';
    colorInput.value = era.color;
    if (colorHex) colorHex.textContent = era.color;
    privateInput.checked = !!era.is_private;
    deleteBtn.classList.remove('hidden');
  } else {
    if (titleEl) titleEl.textContent = 'Create New Chapter';
    idInput.value = '';
    titleInput.value = '';
    descInput.value = '';
    startInput.value = store.meta.birthdate;
    endInput.value = '';
    colorInput.value = '#3b82f6';
    if (colorHex) colorHex.textContent = '#3b82f6';
    privateInput.checked = false; // Default to public showcase
    deleteBtn.classList.add('hidden');
  }

  modal.classList.remove('hidden');
}

export function closeEraModal(): void {
  const modal = document.getElementById('era-modal');
  if (modal) modal.classList.add('hidden');
}
